//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import util from '@/lib/util';

export default {
    name: "business",
    components: {},
    data() {
        return {
            show: false,
            shopId: 0,
            wxReady: false
        }
    },
    methods: {
        collectTicket() {
            this.$router.push({path: '/ticketList/' + this.shopId})
        },
        onClicked() {
            var vm = this;
            if (!vm.wxReady) {
                return
            }
            wx.scanQRCode({
                needResult: 1,
                scanType: ["qrCode", "barCode"],
                success(res) {
                    var result = res.resultStr;
                    result = result + '/' + (vm.shopId).toString();
                    window.open(result)

                }
            })
        },
        goToDetail() {
            this.$router.push({path: '/businessDetail/'})
        },
        cancle() {
            this.show = false;
        },
        confirm() {
            // console.log(1111)
        }
    },
    created() {
        this.shopId = parseInt(this.$route.params.shopId)
    },
    mounted() {
        var vm = this;
        abp.ajax.get(
            util.ApiUrl +
            "api/services/app/WeiXin/GetSingture?url=" +
            encodeURIComponent(location.origin + location.pathname)
        )
            .then(result => {
                var configModel = result.data.result;
                // console.log(configModel);
                wx.config({
                    // debug: true,
                    appId: configModel.appId,
                    timestamp: configModel.timestamp,
                    nonceStr: configModel.nonceStr,
                    signature: configModel.signature, // 必填，签名
                    jsApiList: ["scanQRCode"]
                });
                wx.ready(() => {
                    vm.wxReady = true;
                });
                wx.error(res => {
                    vm.wxReady = false;
                    // console.log(res);
                });
            });
    }
}
